import { FormulaEquation, FormulaDescriptorDetail } from '../types';
import { ANEXO_VI_DESCRIPTORS } from '../data/descriptors';

/**
 * Look up official descriptor details for a given equation from Anexo VI descriptors.
 */
export function getDescriptorsForFormula(equation: FormulaEquation): {
  primary: FormulaDescriptorDetail;
  alternates: FormulaDescriptorDetail[];
} {
  const primaryDesc = ANEXO_VI_DESCRIPTORS.find(
    (d) => d.id === equation.descriptorCode || d.code === equation.descriptorCode
  );

  const primary: FormulaDescriptorDetail = {
    code: primaryDesc ? `${primaryDesc.code} (${primaryDesc.subject})` : equation.descriptorCode,
    theme: primaryDesc?.theme || 'Matriz de Referência',
    description: primaryDesc?.description || 'Habilidade oficial associada à fórmula.',
  };

  const alternates: FormulaDescriptorDetail[] = [];
  if (equation.alternateDescriptorCodes) {
    for (const altCode of equation.alternateDescriptorCodes) {
      const altDesc = ANEXO_VI_DESCRIPTORS.find((d) => d.id === altCode || d.code === altCode);
      if (altDesc) {
        alternates.push({
          code: `${altDesc.code} (${altDesc.subject})`,
          theme: altDesc.theme,
          description: altDesc.description,
          contextNote: 'Mapeamento contextual adicional catalogado.',
        });
      }
    }
  }

  return { primary, alternates };
}
